import { API } from 'app/utils/client';
import { IResource } from 'app/models';
import { CRUDService } from './api';

export class ResourceService extends CRUDService<IResource> { }

const instance = new ResourceService(API, 'v1/resources');
export default instance;
